module.exports = __webpack_public_path__ + "img/digital_zichan.e7d6e546.png";